/* eslint-disable */
export default [
  {
    header: "Paramètres",
    action: "read_project_status",
    resource: "Statut Projet",
  },
  {
    title: "Départements",
    route: "apps-departments-list",
    icon: "HashIcon",
    action: "read_all_departments",
    resource: "Départements",
  },
  {
    title: "Statut Projet",
    route: "apps-project-status-list",
    icon: "GridIcon",
    action: "read_project_status",
    resource: "Statut Projet",
  },
  {
    title: "Taxes",
    route: "apps-taxes-list",
    icon: "BarChart2Icon",
    action: "read_taxes",
    resource: "Taxes",
  },
  {
    title: "Pays",
    route: "apps-countries-list",
    icon: "FlagIcon",
    action: "read_countries",
    resource: "Pays",
  },
  {
    title: "Mesures",
    route: "apps-measures-list",
    icon: "UnderlineIcon",
    action: "read_all_measures",
    resource: "Mesures",
  },
  {
    title: "Marques",
    route: "apps-item-brands-list",
    icon: "TypeIcon",
    action: "read_all_brands",
    resource: "Marques",
  },
  {
    title: "Catégories",
    route: "apps-item-categories-list",
    icon: "TagIcon",
    action: "read_all_categories",
    resource: "Catégories",
  },
  {
    title: "Produits",
    route: "apps-items-list",
    icon: "PackageIcon",
    action: "read_all_products",
    resource: "Produits",
  },
];
